'use client';

import { FileText } from 'lucide-react';
import { FeatureGate } from '@/components/features';
import { Badge } from '@/components/ui/badge';

function TermsPageContent() {
 return (
 <div className="min-h-screen bg-black text-neutral-200 font-sans selection:bg-blue-500/30">
 <div className="p-8 pt-24">
 {/* Header */}
 <div className="mb-8">
 <div className="flex items-center gap-3 mb-2">
 <FileText className="h-8 w-8 text-blue-400"/>
 <h1 className="text-3xl font-bold text-white">Terms of Service</h1>
 <Badge className="bg-emerald-500/20 text-emerald-400 border-emerald-500/30">
 Alpha Preview
 </Badge>
 </div>
 <p className="text-neutral-400 mt-1">Review our terms and conditions</p>
 </div>

 {/* Coming Soon Card */}
 <div className="border border-neutral-800 rounded-lg bg-neutral-900/50 p-12 text-center">
 <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
 <FileText className="h-8 w-8 text-blue-400"/>
 </div>
 <h2 className="text-xl font-semibold text-white mb-2">Coming Soon</h2>
 <p className="text-neutral-400 max-w-md mx-auto">
 Our Terms of Service are being finalized.
 Please contact your administrator for any questions regarding usage policies.
 </p>
 </div>
 </div>
 </div>
 );
}

export default function TermsPage() {
 return (
 <FeatureGate featureTier="alpha">
 <TermsPageContent />
 </FeatureGate>
 );
}
